import '../headline/index.js';
import '../icon/index.js';

import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '../../../lib/component.js';
import headerstyles from './style.scss';
import {classMap} from 'lit/directives/class-map.js';

export const COMPONENT_TAG = 'fly-header';

type PlacementOptions = 'left' | 'right';

/**
 * FlyHeader
 */
@customElement(COMPONENT_TAG)
export default class FlyHeader extends FlywheelComponent {
  @property({type: Boolean})
  showActions = true;

  @property()
  title = '';

  @property()
  caption = '';

  @property()
  icon = '';

  @property()
  placement?: PlacementOptions;

  /**
   * Styles
   */
  static get styles() {
    return [headerstyles];
  }

  /**
    Renderer
   * @override
   */
  render() {
    return html`
      <header class="fly-header">
        <div
          class="fly-header__content ${classMap({
            'fly-header__content--placement-left': this.placement === 'left',
          })}"
        >
          <div class="fly-header__left">
            <fly-headline size="lg">
              ${this.icon ? html`<fly-icon icon=${this.icon}></fly-icon>` : ''}
              <slot name="headline"></slot>
              ${this.title}
            </fly-headline>
            <div class="fly-header__left__caption">${this.caption}</div>
            <slot></slot>
          </div>
          ${this.showActions
            ? html`
                <div class="fly-header__right">
                  <slot name="actions"></slot>
                </div>
              `
            : ''}
        </div>
      </header>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'fly-header': FlyHeader;
  }
}
